/**
 * Decodes the adjustments array and return a more readable object
 * @param {!string} xmlSectionString
 * @returns {Array<Object>} returns an array of adjustment objects
 */
export default (section) => {
  const adj = section.adj ? section.adj.split(';') : [];
  return adj.map(adjStr => {
    const singleAdj = adjStr.split(',');
    return {
      row:  +singleAdj[0] || 0,
      seat: +singleAdj[1] || 0,
      dx:   +singleAdj[2] || 0,
      dy:   +singleAdj[3] || 0,
      da:   +singleAdj[4] || 0,
      dt:   +singleAdj[5] || 0,
      dc:   +singleAdj[6] || 0
    };
  });
};



// WEBPACK FOOTER //
// ./frontend/react/sim/parser-mnx-geometry/src/decoders/adjustments_decoder.js